export default {"src":"/_next/static/media/SPOT.5fae9b35.svg","height":18,"width":18};